import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { UserClient } from "../../../store/repsaApi";

const client = new UserClient(app_uri, axiosClient());

export default client;
